// extracted by mini-css-extract-plugin
export var required = "_gt-0";